import { __, Alert, confirm } from 'modules/theme';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import APIManager from 'modules/common/apiManager';
import {
  ModalTrigger,
  Pagination,
  Button,
  ButtonCommonTheme,
  FormControl,
  Table,
  Label,
  DataWithLoader,
  FormGroup,
  ControlLabel
} from 'modules/theme';
import {
  ModalFooter,
  FormWrapper,
  FormColumn,
  ColumnTitle,
  InfoWrapper
} from 'modules/theme';

class CountryAddEdit extends Component {
  constructor(props) {
    super(props);

    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);

    this.mAPI = new APIManager();
    if (this.props.editData) {
      this.state = {
        name: this.props.editData.name,
        iso3: this.props.editData.iso3,
        iso2: this.props.editData.iso2,
        numeric_code: this.props.editData.numeric_code,
        phone_code: this.props.editData.phone_code,
        capital: this.props.editData.capital,
        currency: this.props.editData.currency,
        currency_symbol: this.props.editData.currency_symbol,
        native: this.props.editData.native,
        region: this.props.editData.region,
        subregion: this.props.editData.subregion,
        timezones: this.props.editData.timezones,
        latitude: this.props.editData.latitude,
        longitude: this.props.editData.longitude,
        emoji: this.props.editData.emoji,
        emojiU: this.props.editData.emojiU
      };
    } else {
      this.state = {
        name: '',
        iso3: '',
        iso2: '',
        numeric_code: '',
        phone_code: '',
        capital: '',
        currency: '',
        currency_symbol: '',
        native: '',
        region: '',
        subregion: '',
        timezones: '',
        latitude: '',
        longitude: '',
        emoji: '',
        emojiU: ''
      };
    }
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  resetAllData() {
    this.setState({
      name: '',
      iso3: '',
      iso2: '',
      numeric_code: '',
      phone_code: '',
      capital: '',
      currency: '',
      currency_symbol: '',
      native: '',
      region: '',
      subregion: '',
      timezones: '',
      latitude: '',
      longitude: '',
      emoji: '',
      emojiU: ''
    });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message : "Successfully Done";
      Alert.success(message);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      // Alert.error(`${data.message}`);
      let message = data && data.message ? data.message : "Something wrong happened";
      Alert.error(message);
    }
  }

  saveData(e) {
    let _this = this;
    e.preventDefault();
    const re = /^(\d{1,5})$/;

    if (!re.test(this.state.phone_code)) {
      Alert.error('Enter valid Country Code')
    } else {
      let Name = this.state.name || "";
      Name = Name.trim();
      let tData = {
        name: Name,
        iso3: this.state.iso3,
        iso2: this.state.iso2,
        numeric_code: this.state.numeric_code,
        phone_code: this.state.phone_code,
        capital: this.state.capital,
        currency: this.state.currency,
        currency_symbol: this.state.currency_symbol,
        native: this.state.native,
        region: this.state.region,
        subregion: this.state.subregion,
        timezones: this.state.timezones,
        latitude: this.state.latitude,
        longitude: this.state.longitude,
        emoji: this.state.emoji,
        emojiU: this.state.emojiU
      };
      if (this.props.editData) {
        this.mAPI.sendPostAPI(
          `setting/country/${this.props.editData._id}`,
          tData,
          data => {
            console.log(JSON.stringify(data, null, 2));
            if (data) {
              _this.resetAllData();
              _this.props.closeModal(true);
              Alert.success(`Country ${tData.name} is Updated.`);
            }
          },
          (errorCode, data) => {
            this.apiResponse(errorCode, data);
          },
          'private',
          { id: tData._id },
          'PUT'
        );
      } else {
        this.mAPI.sendPostAPI(
          'setting/country',
          tData,
          data => {
            if (data && data.message) {
              Alert.success(`${data.message}`);
            } else {
              Alert.success(`Successfully Added`);
            }
            this.resetAllData();
          this.props.update();
          this.props.closeModal(true);
          },
          (errorCode, data) => {
            this.apiResponse(errorCode, data);
          }
        );
      }
    }
  }

  render() {
    const { modalType } = this.props;
    const exceptThisSymbols = ["e", "E"];
    return (
      <form onSubmit={e => this.saveData(e)}>
        <FormWrapper>
          {/* <FormColumn></FormColumn> */}
          <FormColumn>
            {this.renderFormGroup('Name', {
              defaultValue: '',
              placeholder: 'Name',
              autoFocus: true,
              required: true,
              id: 'name',
              maxLength: '60',
              value: this.state.name,
              onChange: e => {
                if (e.target && e.target.value) {
                  this.setState({ name: e.target.value });
                } else {
                  this.setState({ name: "" });
                }
              }
            })}
          </FormColumn>
        </FormWrapper>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('ISO3', {
              defaultValue: '',
              placeholder: 'ISO3',
              autoFocus: false,
              required: true,
              id: 'iso3',
              value: this.state.iso3,
              onChange: e => {
                if (e.target.value === ' ') {
                  return false;
                }
                this.setState({ iso3: e.target.value });
              }
            })}
          </FormColumn>
          <FormColumn>
            {this.renderFormGroup('ISO2', {
              defaultValue: '',
              placeholder: 'ISO2',
              autoFocus: false,
              required: true,
              id: 'iso2',
              value: this.state.iso2,
              onChange: e => {
                if (e.target.value === ' ') {
                  return false;
                }
                this.setState({ iso2: e.target.value });
              }
            })}
          </FormColumn>
        </FormWrapper>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('Numberic Code', {
              defaultValue: '',
              placeholder: 'Numberic Code',
              autoFocus: false,
              required: true,
              type: 'number',
              id: 'numeric_code',
              value: this.state.numeric_code,
              onKeyDown: e => {
                exceptThisSymbols.includes(e.key) && e.preventDefault()
              },
              onChange: e => {
                if (e.target.value === ' ') {
                  return false;
                }
                this.setState({ numeric_code: e.target.value });
              }
            })}
          </FormColumn>
          <FormColumn>
            {this.renderFormGroup('Country Code', {
              defaultValue: '',
              placeholder: 'Phone Code',
              autoFocus: false,
              required: true,
              type: 'number',
              id: 'phone_code',
              value: this.state.phone_code,
              onKeyDown: e => {
                exceptThisSymbols.includes(e.key) && e.preventDefault()
              },
              onChange: e => {
                if (e.target.value === ' ') {
                  return false;
                }
                this.setState({ phone_code: e.target.value });
              }
            })}
          </FormColumn>
        </FormWrapper>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('Capital', {
              defaultValue: '',
              placeholder: 'Capital',
              autoFocus: false,
              required: true,
              id: 'capital',
              value: this.state.capital,
              onChange: e => {
                if (e.target.value === ' ') {
                  return false;
                }
                this.setState({ capital: e.target.value });
              }
            })}
          </FormColumn>
        </FormWrapper>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('Currency', {
              defaultValue: '',
              placeholder: 'Currency',
              autoFocus: false,
              required: true,
              id: 'currency',
              value: this.state.currency,
              onChange: e => {
                if (e.target.value === ' ') {
                  return false;
                }
                this.setState({ currency: e.target.value });
              }
            })}
          </FormColumn>
          <FormColumn>
            {this.renderFormGroup('Currency Symbol', {
              defaultValue: '',
              placeholder: 'Currency Symbol',
              autoFocus: false,
              required: true,
              id: 'currency_symbol',
              value: this.state.currency_symbol,
              onChange: e => {
                if (e.target.value === ' ') {
                  return false;
                }
                this.setState({ currency_symbol: e.target.value });
              }
            })}
          </FormColumn>
        </FormWrapper>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('Native', {
              defaultValue: '',
              placeholder: 'Native',
              autoFocus: false,
              required: true,
              id: 'native',
              value: this.state.native,
              onChange: e => {
                if (e.target.value === ' ') {
                  return false;
                }
                this.setState({ native: e.target.value });
              }
            })}
          </FormColumn>
        </FormWrapper>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('Region', {
              defaultValue: '',
              placeholder: 'Region',
              autoFocus: false,
              required: true,
              id: 'region',
              value: this.state.region,
              onChange: e => {
                if (e.target.value === ' ') {
                  return false;
                }
                this.setState({ region: e.target.value });
              }
            })}
          </FormColumn>
          <FormColumn>
            {this.renderFormGroup('Sub Region', {
              defaultValue: '',
              placeholder: 'Sub Region',
              autoFocus: false,
              required: true,
              id: 'subregion',
              value: this.state.subregion,
              onChange: e => {
                if (e.target.value === ' ') {
                  return false;
                }
                this.setState({ subregion: e.target.value });
              }
            })}
          </FormColumn>
        </FormWrapper>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('Timezones', {
              defaultValue: '',
              placeholder: 'timezones',
              autoFocus: false,
              required: true,
              id: 'timezones',
              value: this.state.timezones,
              onChange: e => {
                if (e.target.value === ' ') {
                  return false;
                }
                this.setState({ timezones: e.target.value });
              }
            })}
          </FormColumn>
          <FormColumn>
            {this.renderFormGroup('Latitude', {
              defaultValue: '',
              placeholder: 'Latitude',
              autoFocus: false,
              required: true,
              id: 'latitude',
              value: this.state.latitude,
              onChange: e => {
                if (e.target.value === ' ') {
                  return false;
                }
                this.setState({ latitude: e.target.value });
              }
            })}
          </FormColumn>
          <FormColumn>
            {this.renderFormGroup('Longitude', {
              defaultValue: '',
              placeholder: 'Longitude',
              autoFocus: false,
              required: true,
              id: 'longitude',
              value: this.state.longitude,
              onChange: e => {
                if (e.target.value === ' ') {
                  return false;
                }
                this.setState({ longitude: e.target.value });
              }
            })}
          </FormColumn>
        </FormWrapper>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('Emoji', {
              defaultValue: '',
              placeholder: 'Emoji',
              autoFocus: false,
              required: true,
              id: 'emoji',
              value: this.state.emoji,
              onChange: e => {
                if (e.target.value === ' ') {
                  return false;
                }
                this.setState({ emoji: e.target.value });
              }
            })}
          </FormColumn>
          <FormColumn>
            {this.renderFormGroup('EmojiU', {
              defaultValue: '',
              placeholder: 'EmojiU',
              autoFocus: false,
              required: true,
              id: 'emojiU',
              value: this.state.emojiU,
              onChange: e => {
                if (e.target.value === ' ') {
                  return false;
                }
                this.setState({ emojiU: e.target.value });
              }
            })}
          </FormColumn>
        </FormWrapper>
        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme
            type='greyModalBtn'
            btnStyle="cancel"
            OnClick={() => this.props.closeModal()}
            size="xl"
          >
            Cancel
          </ButtonCommonTheme>
          <ButtonCommonTheme
            type="blueModalBtn"
            btnType="submit"
            btnStyle="default"
            size="xl"
            style={{ float: 'right' }}
          >
            {this.props.editData && this.props.editData._id ? 'Update' : 'Add'}
          </ButtonCommonTheme>
        </ModalFooter>
      </form>
    );
  }
}

CountryAddEdit.propTypes = {
  group: PropTypes.array
};

CountryAddEdit.contextTypes = {
  __: PropTypes.func
};

export default CountryAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/settings/Country/components/CountryAddEdit.js